import { StringField } from '@components/Fields/StringField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IForm } from '@hooks/useForm';
import { IUsuario } from '@model/Usuario';
import { isString } from '@utils/Functions';
import React from 'react';

export type UsuarioEditarFormProps = {
    form: IForm<Partial<IUsuario>>
}

export function UsuarioEditarForm ({ form }: UsuarioEditarFormProps) {
    const { fields } = form;

    React.useEffect(() => {
        const nome = fields.nome.value;
        let nomeUsuario = "";
        
        if (isString(nome)) {
            const p = nome.split(' ');

            if (p.length > 1) {
                const firstName = p.shift();
                const lastName = p.pop();

                nomeUsuario = `${firstName}.${lastName}`.toLocaleLowerCase();
            }
        }

        fields.nomeUsuario.setValue(nomeUsuario);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fields.nome])

    return (
        <HorizontalGrid>
            <GridItem xs={4}>
                <StringField 
                    field={fields.nome}
                    label="Nome"
                    updateFieldStateOnChange
                />
            </GridItem>

            <GridItem xs={4}>
                <StringField 
                    field={fields.nomeUsuario}
                    label="Nome de Usuário"
                />
            </GridItem>
        </HorizontalGrid>
    )
}